'use client';

import '@repo/web-chrome/lib/api-client';

export function InitWebApiClient(): null {
  return null;
}
